import React from 'react';
import classnames from 'classnames';
import { noop, map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/member-search';
import { searchInputPreloader as SearchInputPreloader } from 'ui/views/generic/searchInput';
import { TABLE_TEMPLATE_TYPE } from 'constants/common';

/*******************************/

// success view
const memberSearchWidgetSuccess = ( props ) => {
    return (
        <div className='ui-member-search-widget'>
            <TableSearchWidget
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                requestPayload={ props.requestPayload }
                persistTableData={ true }
                showMemberSearchLiveBadge={ true }
                templateType = { TABLE_TEMPLATE_TYPE.ADVANCED_SEARCH }
            />
        </div>
    );
};

// set display name
memberSearchWidgetSuccess.displayName = 'memberSearchWidgetSuccess';

// set default props
memberSearchWidgetSuccess.defaultProps = {
   componentData: {},
   layoutConfig: {},
   onActionClick: noop,
   requestPayload: {}
};

// prop types
memberSearchWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const memberSearchWidgetPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-member-search-widget-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <SearchInputPreloader
                borderless={ true }
            />
            <div className={ `${ widgetClassName }__advanced-bar` }>
                <div className={ `${ widgetClassName }__advanced-bar__toggle` }></div>
                {
                    map( [ 1, 2, 3, 4, 5 ], ( item ) => {
                        return <div key={ item } className={ `${ widgetClassName }__advanced-bar__item` }></div>;
                    } )
                }
            </div>
        </div>
    );
};

// set display name
memberSearchWidgetPreloader.displayName = 'memberSearchWidgetPreloader';

// set default props
memberSearchWidgetPreloader.defaultProps = {};

// prop types
memberSearchWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberSearchWidget as MemberSearchWidget } from 'ui/views/widgets/memberSearchWidget';
 *
 * // render
 * <MemberSearchWidget propName='propValue'/>
 */
export const memberSearchWidget = withNetworkState( memberSearchWidgetPreloader, memberSearchWidgetSuccess );
